export enum SetPointEventTypeEnum {
    Immediate = 1,
    Scheduled,
    Manual,
    Calculated,
    Imported,
    Allocated,
    Recalculated
}


export function setPointEventTypeText(value: SetPointEventTypeEnum | undefined): string {
    switch(value) {
        case SetPointEventTypeEnum.Immediate: 
            return 'Immediate';

        case SetPointEventTypeEnum.Scheduled: 
            return 'Scheduled';

        case SetPointEventTypeEnum.Manual: 
            return 'Manual';


        case SetPointEventTypeEnum.Calculated: 
            return 'Calculated';

        case SetPointEventTypeEnum.Imported: 
            return 'Imported';

        case SetPointEventTypeEnum.Allocated: 
            return 'Allocated';

        case SetPointEventTypeEnum.Recalculated: 
            return 'Recalculated';

        default: 
            return '';
    }
}